import AppStore from '@v4/store/appStore'
import { useCallback } from 'react'
import { STATUS_TYPE, ALIGN_REL } from '@v4/constants/quiz'
import useStyles from './BackwardsAction.styled'

export const useBackwardsAction = props => {
	const { className, label, withShadow, align } = props
	const result = AppStore.useStoreState(state => state.result.data)
	const { data: question, status, isPrevQuestionExists, isLoading } = AppStore.useStoreState(state => state.question)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const getPrevQuestion = AppStore.useStoreActions(actions => actions.question.getPrevQuestion)
	const classes = useStyles(props)
	const handleClick = useCallback(
		event => {
			event.preventDefault()
			event.stopPropagation()
			if (isBuilderMode) return
			getPrevQuestion({ key: result.key, id: question.id, scorecardId: result.scorecard_id })
		},
		[isBuilderMode, getPrevQuestion, result.key, result.scorecard_id, question.id],
	)

	const show = status === STATUS_TYPE.IN_PROGRESS && isPrevQuestionExists

	return [{ classes, show, className, isLoading, label, withShadow, align: ALIGN_REL[align] }, { handleClick }]
}
